import React from 'react';
import { getSpecialitiesData } from '../data/specialitiesData';

const HospitalSpecialities = ({ specialities }) => {
  // Get the detailed data for selected specialities
  const specialitiesWithData = getSpecialitiesData(specialities || []);

  if (!specialities || specialities.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      {specialitiesWithData.map((speciality, index) => (
        <div key={index} className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow duration-200">
          <div className="flex items-start space-x-4">
            {/* Icon */}
            <div className="flex-shrink-0">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                <svg 
                  className="w-5 h-5 text-blue-600" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" 
                  />
                </svg>
              </div>
            </div>
            
            {/* Content */}
            <div className="flex-1">
              <h4 className="text-lg font-semibold text-gray-900 mb-2">
                {speciality.title}
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                {speciality.description}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HospitalSpecialities;
